import React from 'react'
import Theme from '../../Components/Theme'
import {ThemeProvider} from '../../Context/ThemeContext'
import { Outlet } from 'react-router-dom'

function ContainerPage() {
  return (
    <ThemeProvider>
      <Theme>
        <Outlet />
      </Theme>
    </ThemeProvider>    
  )
}

export default ContainerPage